import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { isAfter, isBefore, isSameDay } from 'date-fns';
import { useDispatch, useSelector } from 'react-redux';

import Form from '@gef-ui/form-material/Form';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import fetch from 'features/common/fetch';
import formDescriptorFn, { ORDER_FORM_NAME } from 'features/views/campaignDashboards/order/form';
import { getTotalOrderNumber } from 'features/views/campaignDashboards/order/selectors';
import { reset } from 'features/views/campaignDashboards/order/slice';
import { number } from 'utils';

import ActionButtons from './components/ActionButtons';
import Filter from './components/Filter';
import OrdersList from './components/OrdersList';

export const OrderModalBody = ({ campaign }) => {
	const dispatch = useDispatch();
	const totalOrderNumber = useSelector(getTotalOrderNumber);

	const today = new Date();
	const orderActive =
		(isSameDay(today, new Date(campaign.orderStartDate)) || isAfter(today, new Date(campaign.orderStartDate))) &&
		(isSameDay(today, new Date(campaign.orderEndDate)) || isBefore(today, new Date(campaign.orderEndDate)));

	useEffect(
		() => () => {
			dispatch(reset());
		},
		[dispatch],
	);

	return (
		<Form name={ORDER_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<Stack
				spacing={4}
				sx={{
					minWidth: 900,
				}}
			>
				<SectionHeader text={campaign.fullName} />
				<Filter campaign={campaign} />
				<ComponentLoader fetchStorePath={`${fetch.constants.urls.campaignOrder}.get`}>
					<OrdersList campaignId={campaign.id} disabled={!orderActive} />
				</ComponentLoader>
				<Grid container>
					<Grid size={1} />
					<Grid
						sx={{
							textAlign: 'right',
							borderTop: '1px solid',
							borderColor: 'grey.400',
							pl: 1,
						}}
						size={10}
					>
						<Typography
							variant="h5"
							color="grey.400"
							sx={{
								pt: 1,
							}}
						>
							{`${getLabelMessage('order:totalOrder')} : ${number(totalOrderNumber)}
					${getLabelMessage('order:pieces')}`}
						</Typography>
					</Grid>
					<Grid size={1} />
				</Grid>
				<ActionButtons campaign={campaign} orderActive={orderActive} />
			</Stack>
		</Form>
	);
};

OrderModalBody.propTypes = {
	campaign: PropTypes.object,
};

export default OrderModalBody;
